import useSessionStorage from "./useSessionStorage";

export const FUNDTYPE = Object.freeze({
  ach: "ach",
  netspend: "netspend",
});

export const FUNDTYPE_NAME = Object.freeze({
  ach: "bank account",
  netspend: "Netspend account",
});

/**
 * Parses 'fundType' query string parameter and caches for the session.
 * @returns {string} current fundType
 */
function useFundType() {
  const [fundType, setFundType] = useSessionStorage("vip-fundType");
  const [session] = useSessionStorage("vip-patron-session");
  const params = new URLSearchParams(window.location.search);
  const newFundType = session?.toggles?.netspendEnabled
    ? params.get("fundType")
    : "ach";
  if (newFundType && newFundType !== fundType && newFundType in FUNDTYPE) {
    setFundType(newFundType);
    return newFundType;
  } else if (newFundType === "any") {
    // Special reset value for dev purposes.
    setFundType(undefined);
    return undefined;
  }
  return fundType;
}

export default useFundType;
